import { dishes } from '../dishes/dishes';

export const initialState = {
	allDishes: combineDishes(),
  dish: {},
  warnings: {},
  day: '1',
  hasHover: false,
  currentPage: false,
};

function combineDishes() {
	let allDishes = [];
	const names = Object.keys(dishes);
	for (let i = 0; i < names.length; i++) {
		allDishes.push(...dishes[names[i]])
	}
	return allDishes;
}


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'HAS_HOVER':
      return {...state,
        hasHover: true,
      };
    case 'DAY':
      return {...state,
        day: action.day,
      };
    case 'SET_DISH':
      return {...state,
        dish: action.obj,
      };
    case 'TOGGLE_WARNING':
      return {...state,
        warnings: {...state.warnings,
          [action.name]: action.bool,
        }
      }
    case 'CURRENT_PAGE':
      return {...state,
        currentPage: action.name,
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/gui/reducer.js